export default __webpack_public_path__ + "static/media/market.83ed261b.svg";